import { useGetPatientFormSubmissionsQuery } from '@/core/services/form'
import { useState } from 'react'

export function usePatientFormSubmissions(patientId: string) {
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(5)

  const {
    data: submissionsData,
    isLoading: isSubmissionsLoading,
    error: queryError,
  } = useGetPatientFormSubmissionsQuery(
    {
      patientId,
      skip: Number(page * pageSize),
      limit: Number(pageSize),
      order: 'DESC',
      orderBy: 'createdAt',
    },
    {
      refetchOnFocus: true,
    }
  )

  return {
    submissions: submissionsData?.items ?? [],
    totalCount: submissionsData?.totalCount ?? 0,
    isLoading: isSubmissionsLoading,
    queryError,
    page,
    pageSize,
    setPage,
    setPageSize,
  }
}
